import { HeatmapDef } from "../../type/asset";

export class HeatmapAdapter {
  static toOutputDTO(res: any): HeatmapDef {
    const symptomRanking = res?.symptom_ranking ?? [];

    const adapted = symptomRanking
      .filter((item: any) => item.gender === "0" || item.gender === "1")
      .map((item: any, index: number) => {
        const values = Array.isArray(item.symptoms)
          ? item.symptoms
              .filter(
                (symptom: any) =>
                  typeof symptom?.symptom_body_for_heap_map === "string"
              )
              .map((symptom: any, idx: number) => ({
                id: idx,
                key: symptom.symptom_body_for_heap_map,
                value:
                  symptom.user_count >= 30
                    ? 3
                    : symptom.user_count >= 10
                    ? 2
                    : 1,
              }))
          : [];

        return {
          id: index,
          key: item.gender,
          values,
        };
      })
      .filter((item: any) => item.values.length > 0);

    return adapted.length > 0 ? adapted : [];
  }
}
